export class Content { 
    $key: string; 
    contentType: string = null;
    eventId: string;
    filetype: string;
    contentFileUrl: string;
    name: string;
    sessionId: string;
    sizeInBytes: number;
    position:number;
}


// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/content.ts